import React from 'react'
import { IconButton } from 'shared/ui'

const WithIconState = ({ onClick, closeable, iconSize = 15, className }) => {
  return (
    <IconButton
      className={className}
      name={closeable ? 'done' : 'replay'}
      svg={closeable}
      iconSize={iconSize}
      onClick={onClick}
      size="small"
      tooltip={closeable ? 'Close [shift+c]' : 'Re-open [shift+o]'}
    />
  )
}

export default WithIconState
